import React from 'react';

export default function Error500() {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <h1>500 Internal Server Error</h1>
            <p>アクセスしようとしたページは表示されませんでした。</p>
        </div>
    );
}